/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-16 18:16:45
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-09 18:44:00
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Modal/Modal.tsx
 */
import React, { ReactNode } from 'react';
import css from './Modal.less';
import { Modal as ModalAntd } from 'antd';
import { ErrorBoundary } from 'src/components/ErrorBoundary';

interface IProps {
  children;
  visible?;
  title?;
  onCancel?;
  cancelText?;
  okText?;
  okType?;
  onOk?;
  centered?;
  className?: string;
  width?: number;
  footer?: ReactNode | boolean;
  maskClosable?: boolean;
  afterClose?: () => void;
  destroyOnClose?: boolean;
}

const Modal = (props: IProps) => {
  const {
    children,
    visible,
    title,
    onCancel,
    cancelText,
    className,
    width,
    afterClose,
    ...rest
  } = props;
  return (
    <ModalAntd
      width={width || 520}
      className={`${css.modalContain} ${className || ''}`}
      title={title}
      // onOk={onOk}
      visible={visible}
      onCancel={onCancel}
      cancelText={cancelText}
      // okText={okText}
      // okType={okType}
      footer={null}
      afterClose={afterClose}
      destroyOnClose={true}
      maskClosable={false}
      zIndex={1999}
      {...rest}>
      <ErrorBoundary>{children}</ErrorBoundary>
    </ModalAntd>
  );
};
export default Modal;
